<template>
  <div class="account-info">
    <a-spin :spinning="spinning">
      <breadcrumbs :breadcrumbsData="breadcrumbsDataComputed" #icon>
        <svg class="icon" aria-hidden="true" style="fill: #fff">
          <use xlink:href="#icon-a-shezhi2"></use>
        </svg>
      </breadcrumbs>
      <div class="content">
        <div class="account-wrap">
          <accountInfoTemp
            :accountInfo="accountInfo"
            :getData="getData"
            :countryList="countryList"
            :countryListMap="countryListMap"
          />
          <div class="im-wrap">
            <imContactInfoTemp
              :userImInfo="userImInfo"
              :getData="getData"
            />
          </div>
        </div>
        <div class="address-wrap">
          <addressInfoTemp
            :addressInfo="addressInfo"
            :getData="getData"
            :countryList="countryList"
            :countryListMap="countryListMap"
          />
        </div>
      </div>
    </a-spin>
  </div>
</template>
<script setup>
  import { keyBy } from 'lodash';
  import { ref, onMounted, computed } from "vue";
  import { connectionApi } from "@/server/seller/index";
  import breadcrumbs from "../../breadcrumbs.vue";
  import accountInfoTemp from './accountInfoTemp.vue';
  import addressInfoTemp from './addressInfoTemp.vue';
  import imContactInfoTemp from './imContactInfoTemp.vue';
  import { useUserInfoStore } from '@/storeData/index'
import { CURRENCY_MAPPER } from '@/contants/common'
import { useSellerI18n } from '@/composables/useSellerI18n'

const { st } = useSellerI18n()
const store = useUserInfoStore()
const userInfo = store.userInfo
  const breadcrumbsDataComputed = computed(() => ({
    title: st('settingsAccountInfo.pageTitle'),
    color: "#776D91",
    links: [
      {
        name: st('common.home'),
        path: "/seller/dashboard",
      },
      {
        name: st('settingsConnections.breadcrumbSettings'),
        path: '/seller/connection',
      },
      {
        name: st('settingsAccountInfo.pageTitle'),
        path: "/seller/account-info",
      },
    ],
  }))
  const spinning = ref(false);
  const userImInfo = ref({});
  const countryList = ref([]);
  const countryListMap = ref({});
  const accountInfo = ref({});
  const addressInfo = ref({});

  const getData = async () => {
    spinning.value = true;
    const marketplace = CURRENCY_MAPPER[userInfo.countryCode].host
    const accountInfoRes = await connectionApi.getSellerAccountInfoGetAccountInfo({marketplace});
    const addressInfoRes = await connectionApi.getSellerBillingAddressGetBillingAddressInfo({marketplace});
    const countryListRes = await connectionApi.getSellerAccountInfoGetCountry();
    const userImRes = await connectionApi.getUserIm();
    
    if (addressInfoRes.success) {
      addressInfo.value = addressInfoRes.data;
    }
    if (accountInfoRes.success) {
      accountInfo.value = accountInfoRes.data;
    }
    if (countryListRes.success) {
      const mappedData = countryListRes.data.map(item => {
        item.label = item.englishName
        item.value = item.countryCode;
        return item;
      });
      // 将US排在第一位
      const usItem = mappedData.find(item => item.value === 'US');
      const otherItems = mappedData.filter(item => item.value !== 'US');
      const listData = usItem ? [usItem, ...otherItems] : otherItems;
      countryList.value = listData;
      countryListMap.value = keyBy(listData, 'countryCode');
    }
    if (userImRes.success) {
      userImInfo.value = userImRes.data || {};
    }
    spinning.value = false;
  };

  onMounted(() => {
    getData();
  })

</script>
<style lang="less" scoped>
  .account-info {
    padding: 0 16px;
    .content {
      display: flex;
      .account-wrap {
        width: 50%;
      }
      .address-wrap {
        width: 50%;
        margin-left: 16px;
      }
      .im-wrap {
        margin-top: 16px;
      }
    }
  }
</style>
